export default __webpack_public_path__ + "static/media/cargill.75b35733.svg";